import { Text } from '../../Form/Inputs/Text.js';
import { Textarea } from '../../Form/Inputs/Textarea.js';
import { Hidden } from '../../Form/Inputs/Hidden.js';

export const Premieraccess = (props) => {
    const name = (props.el) ? props.el.name : '';
    const description = (props.el) ? props.el.description : '';
    const id = (props.el) ? props.el.id : '';
    return (
        <>
            <Text name="name" value={name} />
            <Textarea name="description" value={description} />
            <Hidden name="id" value={id} />
        </>
    )
}